import { ClubRoot } from './ClubRoot';

export default ClubRoot;
